(() => {
  if (customElements.get('ds-core-set-picker')) return;
  customElements.define('ds-core-set-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.set = this.dataset.bundlePage === 'true' ? 'core' : 'single';
      const incoming = new URL(location.href).searchParams;
      this.purchase = incoming.get('ds_set_mode') === 'recurring' ? 'recurring' : 'one-time';
      this.cadence = this.purchase === 'recurring' ? incoming.get('ds_set_cadence') : null;
      this.querySelector(`[name="ds_purchase"][value="${this.purchase}"]`).checked = true;
      this.changed = false;
      this.pending = false;
      this.form = this.querySelector('[data-set-form]');
      this.form.removeAttribute('action');
      this.querySelectorAll('[name="ds_set"]').forEach(r => r.addEventListener('change', () => { this.set = r.value; this.render(); }));
      this.querySelectorAll('[name="ds_purchase"]').forEach(r => r.addEventListener('change', () => {
        this.purchase = r.value;
        if (r.value === 'one-time') { this.cadence = null; this.changed = false; }
        this.render();
      }));
      this.el('interval').addEventListener('change', e => { this.cadence = e.target.value || null; this.changed = false; this.render(); });
      this.el('interval-jump').addEventListener('click', e => { e.preventDefault(); this.el('interval').scrollIntoView({block:'center'}); this.el('interval').focus(); });
      this.form.addEventListener('submit', e => this.submit(e));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      document.querySelectorAll('[data-ds-set-colors] a').forEach(a => {
        const url = new URL(a.href);
        if (preview) url.searchParams.set('preview_theme_id', preview);
        a.href = url.href;
      });
      const cartURL = new URL(this.el('cart-link').href);
      if (preview) cartURL.searchParams.set('preview_theme_id', preview);
      this.el('cart-link').href = cartURL.href;
      this.render();
    }
    el(name) { return this.querySelector(`[data-${name}]`); }
    text(name, value) { const el = this.el(name); if (el) el.textContent = value; }
    t(key, values = {}) { return Object.entries(values).reduce((s, [k,v]) => s.replaceAll(`[${k}]`, v), this.labels[key]); }
    plans(product) {
      const list = product.plans.filter(p => p.cadence && /^\d+-month$/.test(p.cadence));
      return list.filter(p => list.filter(x => x.cadence === p.cadence).length === 1).sort((a,b) => parseInt(a.cadence) - parseInt(b.cadence));
    }
    cadenceLabel(value) { const n = parseInt(value); return n === 1 ? this.t('every_month') : this.t('every_months',{count:n}); }
    state() {
      const product = this.catalog[this.set], plans = this.plans(product);
      const recurring = this.purchase === 'recurring';
      const plan = recurring ? plans.find(p => p.cadence === this.cadence) : null;
      return {product, plans, recurring, plan, ready:Boolean(product.id && product.available && this.purchase && (!recurring ? !product.requiresPlan : plan))};
    }
    render() {
      if (this.hasAttribute('data-mixed-plans') && this.purchase === 'recurring' && !this.plans(this.catalog[this.set]).length) {
        this.purchase = ''; this.cadence = null; this.changed = false;
        this.querySelectorAll('[name="ds_purchase"]').forEach(r => { r.checked = false; });
      }
      if (this.hasAttribute('data-mixed-plans') && !this.purchase && this.plans(this.catalog[this.set]).length) {
        this.purchase = 'recurring';
        this.querySelector('[name="ds_purchase"][value="recurring"]').checked = true;
      }
      let {product, plans, recurring, plan, ready} = this.state();
      if (this.el('unavailable-plan')) this.el('unavailable-plan').hidden = Boolean(this.purchase);
      if (this.cadence && !plans.some(p => p.cadence === this.cadence)) { this.cadence = null; this.changed = true; }
      const first = plan || plans[0];
      const name = this.set === 'core' ? this.t('core') : product.title;
      const pairs = this.t(this.set === 'core' ? 'pairs' : 'pair');
      for (const key of ['single','core']) {
        const p = this.catalog[key], firstPlan = this.plans(p)[0];
        const target = this.el(`${key}-price`);
        if (target) {
          target.replaceChildren();
          if (!recurring && key === 'core' && p.compare > p.price) {
            const compare = document.createElement('del'); compare.textContent = p.compareMoney; target.append(compare);
          }
          const amount = document.createElement('span'); amount.textContent = recurring && firstPlan ? firstPlan.money : p.money; target.append(amount);
          if (recurring && firstPlan) { const unit = document.createElement('small'); unit.textContent = this.t('per_delivery'); target.append(unit); }
        }
      }
      const bundle = this.catalog.core;
      this.text('set-saving', recurring && this.plans(bundle).length ? this.t('every_shipment') : bundle.compare > bundle.price ? `${this.t('save_prefix')} ${bundle.savingMoney}` : '');
      this.el('set-shipping').hidden = recurring || bundle.currency !== 'USD' || bundle.country !== 'US' || bundle.price < 9900;
      this.text('purchase-context',this.t('purchase_context',{name,pairs}));
      this.text('once-price', product.money);
      this.text('recurring-price', first?.money || '—');
      this.el('recurring-option').hidden = !plans.length;
      const saving = first && product.price ? Math.round((product.price-first.price)/product.price*100) : 0;
      this.text('recurring-saving',saving > 0 ? this.t('save_delivery',{percent:saving}) : this.t('per_delivery'));
      this.el('interval-wrap').hidden = !recurring;
      const select = this.el('interval');
      select.required = recurring; select.disabled = !recurring || this.pending;
      if (select.dataset.product !== String(product.id)) {
        select.replaceChildren(new Option(this.t('interval_placeholder'),''),...plans.map(p => new Option(this.cadenceLabel(p.cadence),p.cadence)));
        select.dataset.product = String(product.id);
      }
      select.value = this.cadence || '';
      select.setAttribute('aria-invalid',String(recurring && !ready && this.changed));
      this.text('interval-help',this.changed ? this.t('changed') : plan ? this.cadenceLabel(plan.cadence) : this.t('interval_help'));
      this.el('selection-help').hidden = !recurring || Boolean(plan);
      this.text('selection-help-text',this.t(this.set === 'core' ? 'core_selection' : 'single_selection')+' '+this.t(this.changed ? 'changed' : 'interval_help'));
      this.text('selected-copy',this.t('summary',{pairs,name}));
      this.text('shipment-detail',recurring ? (plan ? this.cadenceLabel(plan.cadence) : this.t('choose_interval'))+' · '+(this.set === 'core' ? this.t('every_shipment') : product.title) : this.set === 'core' ? this.t('set_contents') : this.t('one_shipment'));
      this.text('total',recurring ? first?.money || '—' : product.money);
      this.text('total-unit',this.t(recurring ? 'per_delivery' : 'total'));
      this.text('member-note',this.t(recurring ? 'included_saving' : 'member'));
      this.text('shipping',this.t(this.set === 'core' && !this.el('set-shipping').hidden ? 'free_shipping' : 'shipping'));
      const add = this.el('add');
      add.disabled = !ready || this.pending;
      add.textContent = this.pending ? this.t('adding') : !product.available ? this.t('sold_out') : !this.purchase ? this.t('choose_purchase') : !ready ? this.t('choose_interval') : recurring ? this.t('add_recurring') : `${this.t('add')} — ${product.money}`;
      add.setAttribute('aria-label',`${add.textContent}. ${name}. ${pairs}. ${recurring && first ? first.money+' '+this.t('per_delivery') : product.money}`);
      this.form.querySelector('[name="id"]').value = product.id || '';
      const planField = this.form.querySelector('[name="selling_plan"]');
      planField.value = plan?.id || ''; planField.disabled = !plan;
      document.querySelectorAll('[data-ds-set-colors] a').forEach(a => {
        const url = new URL(a.href);
        url.searchParams.delete('ds_set_mode'); url.searchParams.delete('ds_set_cadence');
        if (recurring) { url.searchParams.set('ds_set_mode','recurring'); if (this.cadence) url.searchParams.set('ds_set_cadence',this.cadence); }
        a.href = url.href;
      });
      this.el('notice').hidden = true;
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const {product, plan, ready} = this.state();
      if (this.pending || !ready) return;
      this.pending = true;
      this.render();
      this.querySelectorAll('input[type="radio"]').forEach(r => { r.dataset.wasDisabled = String(r.disabled); r.disabled = true; });
      const item = {id:product.id,quantity:1};
      if (plan) item.selling_plan = plan.id;
      let confirmed = false, uncertain = false;
      try {
        const result = await this.addItem(item);
        const added = result.items?.find(line => String(line.variant_id || line.id) === String(item.id) && String(line.selling_plan_allocation?.selling_plan?.id || '') === String(item.selling_plan || ''));
        if (!added) throw new TypeError('Unconfirmed cart add');
        confirmed = true;
        this.lastAdded = added;
      } catch (error) {
        uncertain = error instanceof TypeError || error instanceof SyntaxError;
        this.lastError = uncertain ? this.t('error') : error.message;
      }
      if (confirmed) await this.openCart();
      this.pending = false;
      this.querySelectorAll('input[type="radio"]').forEach(r => { r.disabled = r.dataset.wasDisabled === 'true'; });
      this.render();
      this.el('notice').hidden = false;
      this.text('notice-text',confirmed ? this.t('added') : this.lastError);
      if (!confirmed) {
        if (uncertain) this.el('add').disabled = true;
        this.el('notice').focus();
      }
    }
    async addItem(item) {
      if (window.Rebuy?.Cart?.addItem) {
        return new Promise((resolve,reject) => {
          const timeout = setTimeout(() => reject(new TypeError('Cart add timeout')),20000);
          window.Rebuy.Cart.addItem({items:[item]}, {
            success: result => { clearTimeout(timeout); resolve(result); },
            error: error => {
              clearTimeout(timeout);
              const response = error.cause?.res;
              reject(response ? new Error(response.description || response.message || this.t('error')) : new TypeError(this.t('error')));
            }
          });
        });
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.t('error'));
      return result;
    }
    cartContainsAdded(cart) {
      const added = this.lastAdded;
      if (!added) return false;
      return cart?.items?.some(item =>
        String(item.variant_id || item.id) === String(added.variant_id || added.id) &&
        String(item.selling_plan_allocation?.selling_plan?.id || '') === String(added.selling_plan_allocation?.selling_plan?.id || '') &&
        item.quantity >= added.quantity
      );
    }
    async openCart() {
      try {
        const cart = window.Rebuy?.Cart, drawer = window.Rebuy?.SmartCart;
        if (!cart?.fetchShopifyCart || !drawer?.setCart || !drawer?.show) throw new Error('Cart drawer unavailable');
        for (let attempt = 0; attempt < 3; attempt++) {
          const current = await new Promise((resolve,reject) => {
            const timeout = setTimeout(() => reject(new Error('Cart refresh timeout')),3000);
            cart.fetchShopifyCart(value => { clearTimeout(timeout); resolve(value); });
          });
          if (this.cartContainsAdded(current) && drawer.status === 'ready') {
            drawer.setCart(current);
            await new Promise(resolve => setTimeout(resolve,100));
            if (this.cartContainsAdded(drawer.cart)) {
              drawer.show();
              return;
            }
          }
          if (attempt < 2) await new Promise(resolve => setTimeout(resolve,250));
        }
      } catch {}
      location.assign(this.el('cart-link').href);
    }
  });
})();
